import Layout from 'layouts'
import RegisterAffiliatePage from 'pages/Affiliate/RegisterAffiliatePage'
import AccountLayout from 'pages/User/accountLayout/AccountLayout'
import React, { lazy } from 'react'
import { Redirect, Route as ReactRouter, Switch } from 'react-router-dom'
import useAuth from 'store/AuthContext'

const AllCategoryPage = lazy(() => import('pages/AllCategoryPage'))
const BrandPage = lazy(() => import('pages/BrandPage'))
const BlockPage = lazy(() => import('pages/BlockPage'))
const CategoryPage = lazy(() => import('pages/CategoryPage'))
const Error404Page = lazy(() => import('pages/Error404Page'))
const InfoPage = lazy(() => import('pages/InfoPage'))
const Landing = lazy(() => import('pages/Landing/LandingPage'))
const ProductPage = lazy(() => import('pages/Product/ProductPage'))
const PromotionsPage = lazy(() => import('pages/PromotionsPage'))
const SalesPage = lazy(() => import('pages/SalesPage'))
const SearchPage = lazy(() => import('pages/SearchPage'))
const SinglePost = lazy(() => import('pages/SinglePost'))
const SingleOrderPage = lazy(() => import('pages/User/SingleOrderPage'))
const PurchasePage = lazy(() => import('pages/PurchasePage'))
const WishlistPage = lazy(() => import('pages/WishlistPage'))
const HomePage = lazy(() => import('pages/HomePage'))
const Tab3KidsPage = lazy(() => import('pages/Tab3Kids'))
const MobileLandingPage = lazy(() => import('pages/MobileLanding'))
const BudeLandingPage = lazy(() => import('pages/BudeLanding'))

export const routes = [
  {
    path: '/',
    exact: true,
    component: HomePage,
  },

  {
    path: '/all-category',
    component: AllCategoryPage,
  },
  {
    path: '/purchase',
    component: PurchasePage,
  },
  {
    path: '/wishlist',
    component: WishlistPage,
  },
  {
    path: '/category/:slug?/:keyword?',
    component: CategoryPage,
  },
  {
    path: '/search/:keyword',
    component: SearchPage,
  },
  {
    path: '/brand/:slug',
    component: BrandPage,
  },
  {
    path: '/products/:block_id',
    component: BlockPage,
  },
  {
    path: '/sale',
    component: SalesPage,
  },
  // { path: '/page/usafrtxoebis-politika', component: InfoPage },
  // { path: '/page/terms-and-conditions', component: InfoPage },
  // { path: '/page/mitsodebis-pirobebi', component: InfoPage },
  // { path: '/page/khshirad-dasmuli-kitkhvebi', component: InfoPage },
  // { path: '/page/garantia-dabruneba-gadatsvla', component: InfoPage },
  // { path: '/page/about-us', component: InfoPage },
  {
    path: '/affiliate/register',
    component: RegisterAffiliatePage,
  },
  {
    path: '/page/:slug',
    component: InfoPage,
  },
  {
    path: '/landing/mamkcwzsby',
    component: Tab3KidsPage,
    layoutProps: {
      excludeHeader: true,
      excludeFooter: true,
    },
  },
  {
    path: '/landing/tiytbnz6pi',
    component: BudeLandingPage,
    layoutProps: {
      excludeHeader: true,
      excludeFooter: true,
    },
  },
  {
    path: '/landing/kllbg22pz8',
    component: MobileLandingPage,
    layoutProps: {
      excludeHeader: true,
      excludeFooter: true,
    },
  },
  {
    path: '/landing/:signature',
    component: Landing,
    layoutProps: {
      layoutType: 'landing',
    },
  },
  {
    path: '/post/:slug',
    component: SinglePost,
  },
  {
    path: '/product/:slug/:path?',
    component: ProductPage,
  },
  {
    path: '/account',
    secured: true,
    component: AccountLayout,
  },

  {
    path: '/order/:hash',
    // guest: true,
    component: SingleOrderPage,
  },
  {
    path: '/promotions/:slug?',
    component: PromotionsPage,
  },
  {
    path: '/*',
    component: Error404Page,
  },
]

export const renderRoutes = (routes, extraProps = {}, switchProps = {}) => {
  return (
    <Switch {...switchProps}>
      {routes.map((route, i) => {
        const render = props => {
          const LayoutComponent = route.layout || Layout
          const layoutProps = route.layoutProps || {}

          if (route.render) {
            return (
              <LayoutComponent {...layoutProps}>
                {route.render({ ...props, ...extraProps, route: route })}
              </LayoutComponent>
            )
          } else if (route.component) {
            return (
              <LayoutComponent {...layoutProps}>
                <route.component {...props} {...extraProps} route={route} />
              </LayoutComponent>
            )
          }
        }

        return (
          <Route
            key={route.key || i}
            path={route.path}
            exact={route.exact}
            guest={route.guest}
            secured={route.secured}
            strict={route.strict}
            render={render}
          />
        )
      })}
    </Switch>
  )
}

export const Route = ({ secured, guest, ...props }) => {
  const { auth, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-citrus-red mx-auto mb-2"></div>
          <p className="text-slate-600">იტვირთება...</p>
        </div>
      </div>
    )
  }

  if (secured && !auth) return <Redirect to="/" />
  if (guest && auth) return <Redirect to="/" />

  return <ReactRouter {...props} />
}
